import React, { ReactElement, useEffect, useState, useRef } from "react";

import { AnimationData } from "../../assets/glb/animations";
import { LisaAvatar } from "../LisaAvatar";
import { LisaContainer, Container } from "./styles";
import { AnimationControls } from "../AnimationControls";

interface LisaHomeProps {
  animation: AnimationData[];
  repeat: boolean;
  headerAnimation: AnimationData[];
  setRepeat: React.Dispatch<React.SetStateAction<boolean>>;
  setAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  isHomeActive?: boolean;
  showTimer?: boolean;
}

export function LisaHome({
  animation,
  repeat,
  headerAnimation,
  setRepeat,
  setAnimation,
  showTimer = true,
  isHomeActive = false,
}: LisaHomeProps) {
  const [animationSpeed, setSpeed] = useState(1);
  const [animating, setAnimating] = useState(false);
  const [wasRecognized, setWasRecognized] = useState("");
  const [recognitionFeedback, setRecognitionFeedback] = useState<ReactElement | null>();
  const [showingMessage, setShowingMessage] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);
  const [playerTimeMs, setPlayerTimeMs] = useState(0);
  const [totalDuration, setTotalDuration] = useState(0);

  useEffect(() => {
    if (animation.length > 0) {
      setAnimating(true);
      setPlayerTimeMs(0);
    }
  }, [animation]);

  useEffect(() => {
    if (repeat) {
      setAnimating(true);
    }
  }, [repeat]);

  useEffect(() => {
    const onInterrupt = () => setIsPaused(true);
    const onResume = () => setIsPaused(false);

    window.addEventListener("LISA_INTERRUPT", onInterrupt);
    window.addEventListener("LISA_RESUME", onResume);

    return () => {
      window.removeEventListener("LISA_INTERRUPT", onInterrupt);
      window.removeEventListener("LISA_RESUME", onResume);
    };
  }, []);

  const videoRef = useRef<HTMLVideoElement>(null);

  

  function handleFeedbackMessage(component: ReactElement) {
    setRecognitionFeedback(component);
    setShowingMessage(true);
    setTimeout(() => {
      setRecognitionFeedback(null);
      setShowingMessage(false);
      setWasRecognized("");
    }, 3000);
  }


  return (
    <Container ref={containerRef} >
      <LisaContainer >
        {wasRecognized && recognitionFeedback}

          <LisaAvatar
            animatingSpeed={animationSpeed}
            repeat={repeat}
            setRepeat={setRepeat}
            animation={animation}
            setAnimating={setAnimating}
            isHomeActive={isHomeActive}
            parentDiv={containerRef}
            isPaused={isPaused}
            setPlayerTimeMs={setPlayerTimeMs}
            setTotalDuration={setTotalDuration}
          />

         
      </LisaContainer>
      {showTimer && (
        <AnimationControls
          repeat={repeat}
          headerAnimation={headerAnimation}
          animation={animation}
          setRepeat={setRepeat}
          setAnimation={setAnimation}
          animationSpeed={animationSpeed}
          setSpeed={setSpeed}
          isPaused={isPaused}
          setIsPaused={setIsPaused}
          playerTimeMs={playerTimeMs}
          totalDuration={totalDuration}
        />
      )}

    </Container>
  );
}